import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.starts-with";
import "core-js/modules/web.dom-collections.iterator";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import BranchLink from "web/react/components/branch-link/branch-link";
import MultiplyOnHoverButton from "web/react/components/buttons/multiply-on-hover-button/multiply-on-hover-button";
import { openCustomerCaptureOverlay } from "web/redux/ducks/customer-capture-overlay";
import analytics from "web/script/analytics/analytics";
import environment from "web/script/modules/environment";
import requester from "web/script/modules/requester";
import { RawBranchLink } from "web/script/utils/branch-io";
import browser from "web/script/utils/browser";
export function FollowDesignerButton(_ref) {
  var lystId = _ref.lystId,
      followedText = _ref.followedText,
      notFollowedText = _ref.notFollowedText,
      isAuthenticated = _ref.isAuthenticated,
      isFollowing = _ref.isFollowing,
      openCustomerCaptureOverlay = _ref.openCustomerCaptureOverlay,
      analyticsParameters = _ref.analyticsParameters,
      className = _ref.className;

  var _useState = useState(isFollowing != "false"),
      _useState2 = _slicedToArray(_useState, 2),
      following = _useState2[0],
      setFollowing = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isIos = _useState4[0],
      setIsIos = _useState4[1];

  useEffect(function () {
    setIsIos(browser.ios); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [browser.ios]);

  function follow() {
    return requester.post("/api/users/add/", "lyst_id=".concat(lystId)).then(function () {
      setFollowing(true);
      analytics.event("Follow Button", "Follow - Success", undefined, true);
    }).catch(function () {
      analytics.event("Follow Button", "Follow - Error", undefined, true);
    });
  }

  function unFollow() {
    return requester.post("/api/users/remove/", "lyst_id=".concat(lystId)).then(function () {
      setFollowing(false);
      analytics.event("Follow Button", "Unfollow - Success", undefined, true);
    }).catch(function () {
      analytics.event("Follow Button", "Unfollow - Error", undefined, true);
    });
  }

  var pageSubType = environment.get("pageSubType");
  var buttonLabel = following ? followedText : notFollowedText;

  var _analyticsParameters = _slicedToArray(analyticsParameters, 3),
      category = _analyticsParameters[0],
      action = _analyticsParameters[1],
      label = _analyticsParameters[2];

  function onClick() {
    analytics.event(category, action, label);

    if (isAuthenticated === "false") {
      openCustomerCaptureOverlay({
        designerId: lystId,
        captureType: "signup_du"
      });
    } else if (following) {
      unFollow();
    } else {
      follow();
    }
  }

  if (pageSubType && pageSubType.startsWith("designer") && isAuthenticated === "false" && isIos && environment.getFeature("mg_du_banner_ios_to_app")) {
    return React.createElement(BranchLink, {
      title: buttonLabel,
      className: className,
      branchLink: RawBranchLink.DesignerUpdates,
      eventLabel: "follow_designer_button",
      primaryButton: true
    });
  }

  return React.createElement(MultiplyOnHoverButton, {
    className: className,
    onClick: onClick,
    disabled: false,
    fullWidth: false,
    fullHeight: false,
    openInNewTab: false
  }, buttonLabel);
}
export default connect(null, {
  openCustomerCaptureOverlay: openCustomerCaptureOverlay
})(FollowDesignerButton);